import request from '../utils/request';

export function getCheckBinding (){
    return request({
        url: "/wxmanager/person/checkBinding",
        method:'post',
    });
}
export function getCheckInformed(){
    return request({
        url: "/wxmanager/person/checkInformed",
        method:'post',
    });
}
export function getCheckBaseRiskInfo(){
    return request({
        url: "/wxmanager/person/checkBaseRiskInfo",
        method:'post',
    });
}